import type { UserRolesPermission } from '../../../lib/flotiq-client/types/api-response';
import type { RolePermissionFormValues } from './initialValues';

export const transformValues = (values: RolePermissionFormValues) => ({
  description: values.description,
  name: values.name,
  permissions: [...values.ctd_permissions, ...values.co_permissions].map(
    (permission) => ({
      ...permission,
      contentTypeDefinition: permission.contentTypeDefinition?.id
        ? { id: permission.contentTypeDefinition.id }
        : null,
      attributesPermission: transformAttributes(
        permission.type,
        permission.attributesPermission,
        permission.contentTypeDefinition?.metaDefinition?.order,
      ),
    }),
  ),
});

const transformAttributes = (
  type: string,
  attributesPermission: UserRolesPermission['attributesPermission'],
  order: string[] = [],
) => {
  if (type === 'CTD' || !attributesPermission) return;

  let hasAnyAttribute = false;

  const newAttributes = Object.entries(attributesPermission || {}).reduce(
    (acc, [key, value]) => {
      if (!value?.length || value.length === order.length) {
        acc[key] = undefined;
      } else {
        hasAnyAttribute = true;
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, undefined | string[]>,
  );

  return hasAnyAttribute ? newAttributes : undefined;
};
